import { createSlice } from '@reduxjs/toolkit';
import { Map } from 'immutable';

import ScheduleBuilderSession from 'features/scheduleBuilder/ScheduleBuilderView/resources/ScheduleBuilderSession';

import { captureHydrationException } from '../helpers';
import type { SessionFetchAction } from '../types';

import { PARENT_SLICE_NAME, SLICE_NAME } from './constants';
import type { SessionSerializedEntity, SessionState } from './types';

const initialState: SessionState = {
  canManageEmployees: false,
  status: 'idle',
};

export const sliceState = (state: { [x: string]: any }) =>
  state.get(PARENT_SLICE_NAME)?.[SLICE_NAME];

export const selectCanManageEmployees = (state: Map<string, any>): boolean =>
  sliceState(state)?.canManageEmployees;

export const selectColorMappingVersion = (
  state: Map<string, any>
): number | undefined => sliceState(state)?.colorMappingVersion;

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      ScheduleBuilderSession.resourceActionEvent('fetch'),
      (state, action: SessionFetchAction) => {
        state.status = 'succeeded';
        if (action.payload?.data) {
          try {
            const session: SessionSerializedEntity = action?.payload?.data;
            if (session?.attributes) {
              state.canManageEmployees = session.attributes.canManageEmployees;
              state.colorMappingVersion =
                session.attributes.colorMappingVersion;
            }
            if (session?.relationships) {
              const flattenedRelationships = Object.fromEntries(
                Object.entries(session.relationships || {}).map(
                  ([k, v]: [string, any]) => [k, v.data]
                )
              );
              state.currentLocation = flattenedRelationships?.currentLocation;
              state.currentUser = flattenedRelationships?.currentUser;
              state.departments = flattenedRelationships?.departments;
              state.templates = flattenedRelationships?.templates;
              state.locations = flattenedRelationships?.locations;
            }
          } catch (error) {
            captureHydrationException(state, error, SLICE_NAME);
          }
        }
      }
    );
  },
});

export const reducer = slice.reducer;
